__turbopack_context__.v({
  "given": "letterBox-module__4OuYgW__given",
  "inactive": "letterBox-module__4OuYgW__inactive",
  "inactiveEntry": "letterBox-module__4OuYgW__inactiveEntry",
  "letterBox": "letterBox-module__4OuYgW__letterBox",
  "solved": "letterBox-module__4OuYgW__solved",
});
